import { Injectable } from '@angular/core';
import { APPCONFIG } from '../_store';
@Injectable({
    providedIn: 'root'
})
export class AppThemeService {
    appTheme = APPCONFIG.appThemeConfig.payex;
    constructor() {
        // sessionStorage is populated by the early-detection script in index.html
        // before Angular bootstraps, so the app name is always available here
        const appName = sessionStorage.getItem("appName");
        if (appName) {
            this.setAppConfig(appName);
        }
    }

    setAppConfig(appName: string) {
        sessionStorage.setItem("appName", appName);
        this.appTheme = APPCONFIG.appThemeConfig[appName] || APPCONFIG.appThemeConfig.payex;
        document.title = this.appTheme.title;

        // Update favicon
        ['page_favicon', 'page_apple_favicon'].forEach(docId => {
            const element = document.getElementById(docId);
            if (element) {
                element.setAttribute('href', this.appTheme.favIcon);
            }
        });

        // Dynamically load client-specific theme CSS
        this.loadThemeCss(this.appTheme.cssFile);
    }

    loadThemeCss(cssFile: string) {
        const existingLink = document.getElementById('css_dynamic_client_theme') as HTMLLinkElement;
        if (!cssFile) {
            // Remove any previously loaded client theme
            if (existingLink) {
                existingLink.remove();
            }
            return;
        }
        if (existingLink) {
            existingLink.setAttribute('href', cssFile);
        } else {
            const link = document.createElement('link');
            link.id = 'css_dynamic_client_theme';
            link.rel = 'stylesheet';
            link.type = 'text/css';
            link.href = cssFile;
            document.head.appendChild(link);
        }
    }
}
